import { takeLatest, call } from 'redux-saga/effects'
import * as fromLessonActions from '../../actions/lessons-admin.action'
import createLesson from '../../../api/administration/lessons/Create'
import getCourse from 'api/administration/courses/Get'
import { ILessonModel } from 'models/lesson.model'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

async function handleGetCourse(courseId: number) {
  return await getCourse(courseId)
}

async function handleCreateLesson(data: ILessonModel) {
  return await createLesson(data)
}

function* createLessonEffectSaga(action: any) {
  try {
    const {
      payload: { courseId, lesson, history },
    } = action
    const { lessons } = yield call(handleGetCourse, courseId)
    const newLesson = {
      ...lesson,
      order: lessons.length + 1,
      course_id: courseId,
    }
    const {
      data: { id },
    } = yield call(handleCreateLesson, newLesson)
    history.push(`/administration/courses/${courseId}/lessons/${id}/edit`)
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* createLessonWatcherSaga() {
  yield takeLatest(fromLessonActions.CREATE_LESSON, createLessonEffectSaga)
}
